import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@mui/material';
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { BackdropLoader } from '@livable/saas-react-components';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
export const PortfoliosSmartNav = observer(_ref => {
  let name = _ref.name,
    _ref$isIcon = _ref.isIcon,
    isIcon = _ref$isIcon === void 0 ? false : _ref$isIcon,
    _ref$isFilter = _ref.isFilter,
    isFilter = _ref$isFilter === void 0 ? true : _ref$isFilter,
    subtitle = _ref.subtitle,
    isLoadingExt = _ref.isLoadingExt,
    portfoliosList = _ref.portfoliosList,
    selectedPortfolio = _ref.selectedPortfolio,
    setSelectedPortfolio = _ref.setSelectedPortfolio,
    triggerRefresh = _ref.triggerRefresh;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smartNav, " ").concat(!isOpen ? 'close' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smartNavControll, " ").concat(!isOpen ? 'close' : ''),
    onClick: () => setIsOpen(!isOpen)
  }, /*#__PURE__*/React.createElement("span", null, name), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-left"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavSetting
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavSettingSearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    fullWidth: true,
    placeholder: t('general.search'),
    onChange: event => {
      var _event$target;
      return setSearchKey((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    }
  })), /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    triggerRefresh: triggerRefresh,
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '737-portfolios-smart-nav'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }))
  })), isFilter && /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavSettingFilter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '738-portfolios-smart-nav'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "filter"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Filters")))), /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavBodyList
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smartNavItem, " ").concat(selectedPortfolio === 'all-portfolios' ? 'active' : ''),
    key: 'all-portfolios',
    id: 'all-portfolios',
    onClick: () => setSelectedPortfolio('all-portfolios'),
    'custom-attribute': '739-portfolios-smart-nav'
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavItemDetails
  }, /*#__PURE__*/React.createElement("b", null, "All properties")), /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavItemNumber
  }, portfoliosList.reduce((acc, item) => {
    return acc + item.properties.length;
  }, 0))), portfoliosList.filter(i => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(i.name).search(searchPhrase) > 0 : true;
  }).map(portfolio => {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.smartNavItem, " ").concat(selectedPortfolio === portfolio.id ? 'active' : ''),
      key: portfolio.id,
      id: portfolio.id,
      onClick: () => setSelectedPortfolio(portfolio.id),
      'custom-attribute': '740-portfolios-smart-nav-' + portfolio.id
    }, isIcon && /*#__PURE__*/React.createElement("div", {
      className: classes.smartNavItemIcon
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "folder-house",
      state: selectedPortfolio !== portfolio.id ? 'lightGrey' : ''
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.smartNavItemDetails
    }, /*#__PURE__*/React.createElement("b", null, portfolio.name), subtitle && /*#__PURE__*/React.createElement("span", null, subtitle)), /*#__PURE__*/React.createElement("div", {
      className: classes.smartNavItemNumber
    }, portfolio.properties.length));
  })))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoadingExt
  }));
});